<mat-card [ngClass]="isActive ? 'bordered': 'inner'">
  <mat-card-content>
    <div class="text-subtitle c-primary">{{ bankAccount.accountName }}</div>

    <div class="text-body fw-700 c-deep-blue p-relative">
      {{ bankAccount.currentBalance | customCurrency }}
      @if (isActive) {
        <i class="bank-account-icon fa fa-chevron-right"></i>
      }
    </div>

    <div class="text-body c-gray-secondary mt-10">
      {{ bankAccount.accountNumber }} • {{ bankAccountTypes[bankAccount.type] | translate }}
    </div>
  </mat-card-content>
</mat-card>
